<script>
import { noAliveRouterConfig } from '@/config/alive-router-config'
import { clearKeepAliveCaches, clearItemKeepAliveCache } from '@/utils/keepAliveCacheUtil'

export default {
  name: 'RouteView',
  props: {
    keepAlive: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {}
  },
  methods: {
    clearKeepAliveCaches,
    clearItemKeepAliveCache
  },
  created () {
    this.event.$on("clean-keep-alive-cache", () => {
      this.clearKeepAliveCaches('routerViewCacheRef') // 刷新页面或切换组织，清空缓存
    })
    // this.event.$on("batch-clean-keep-alive-cache", (nameList = []) => {
    //   this.clearItemKeepAliveCache('routerViewCacheRef', nameList) // 批量删除页面缓存
    // })
  },
  render () {
    const { $route: { meta }, $store: { getters } } = this
    // 关闭tab页签记录不要缓存页面
    const noAliveRouterList = getters.noAliveRouter;
    // 页面操作关闭不要缓存页面，及配置的不缓存页面汇总
    const noALiveList = [...noAliveRouterList, ...noAliveRouterConfig]
    console.log('noAliveRouterList', noALiveList)
    const inKeep = (
      <keep-alive exclude={noALiveList}>
        <router-view ref="routerViewCacheRef" />
      </keep-alive>
    )
    const savePageInKeep = (
      <keep-alive exclude={noALiveList}>
        <router-view ref="routerViewCacheRef" key={this.$route.fullPath} />
      </keep-alive>
    )
    const notKeep = (
      <router-view key={this.$route.fullPath} />
    )
    // 这里增加了 multiTab 的判断，当开启了 multiTab 时
    // 应当全部组件皆缓存，否则会导致切换页面后页面还原成原始状态
    // 若确实不需要，可改为 return meta.keepAlive ? inKeep : notKeep
    if (!getters.multiTab && !meta.keepAlive) {
      return notKeep
    }
    // 存在部分页面相同，但url不同的情况，为了解决这种场景，要加key为判断实时刷新
    if (meta.savePageAlive) {
      return savePageInKeep
    }
    return this.keepAlive || getters.multiTab || meta.keepAlive ? inKeep : notKeep
  }
}
</script>
